export default {
  ES_ADJUST_EVENT_LOGS: {
    path: '/es-adjust-event-logs',
    name: 'es_adjust_event_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/AdjustEventLogs')
  },
  ES_CLAIMS: {
    path: '/es-claims',
    name: 'es_claims',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'es',
      title: 'Claims',
      order: 2
    },
    component: () => import('@es_views/Claims/ClaimsIndex')
  },
  ES_COHORT_ANALYSIS: {
    path: '/es-cohort-analysis',
    name: 'es_cohort_analysis',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/CohortAnalysis/CohortAnalysisIndex.vue')
  },
  ES_COHORT_ANALYSIS_EXPORT: {
    type: 'function',
    path: 'es_cohort_analysis_export',
    name: 'es_cohort_analysis_export',
    permission: 'es_cohort_analysis_export',
    meta: {
      requiresAuth: true
    }
  },
  ES_EMAILS: {
    path: '/es-emails',
    name: 'es_emails',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'es',
      title: 'E-Mails',
      order: 3
    },
    component: () => import('@es_views/Emails/EmailsIndex')
  },
  ES_PERFORMANCE: {
    path: '/es-performance',
    name: 'es_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/Performance/PerformanceIndex')
  },
  ES_PERFORMANCE_EXPORT: {
    type: 'function',
    path: 'es_performance_export',
    name: 'es_performance_export',
    permission: 'es_performance_export',
    meta: {
      requiresAuth: true
    }
  },
  ES_REWARDS: {
    path: '/es-rewards',
    name: 'es_rewards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/Rewards')
  },
  ES_TRANSACTIONS: {
    path: '/es-transactions',
    name: 'es_transactions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'es',
      title: 'Transactions',
      order: 1
    },
    component: () => import('@es_views/Transactions/TransactionsIndex')
  },
  ES_LEVELS: {
    path: '/es-levels',
    name: 'es_levels',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/Level')
  },
  ES_LEADERBOARDS: {
    path: '/es-leaderboards',
    name: 'es_leaderboards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/Leaderboards/LeaderboardsIndex')
  },
  ES_AFFILIATE_PARTNERS: {
    path: '/es-affiliate-partners',
    name: 'es_affiliate_partners',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/AffiliatePartners/AffiliatePartnersIndex')
  },
  ES_USERS: {
    path: '/es-users',
    name: 'es_users',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/Users/UsersIndex')
  },
  ES_USERS_EXPORT: {
    type: 'function',
    path: 'es_users_export',
    name: 'es_users_export',
    permission: 'es_users_export',
    meta: {
      requiresAuth: true
    }
  },
  ES_USERS_DELETE: {
    type: 'function',
    path: 'es_users_delete',
    name: 'es_users_delete',
    permission: 'es_users_delete',
    meta: {
      requiresAuth: true
    }
  },
  ES_USER_DETAILS: {
    path: '/es-user/:userId',
    name: 'es_user_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'es',
      title: 'User Details',
      order: 0,
      main: true
    },
    component: () => import('@es_views/Users/UserDetails')
  },
  ES_TRIGGERS: {
    path: '/es-triggers',
    name: 'es_triggers',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/Triggers/TriggersIndex')
  },
  ES_LOG_SPEND: {
    path: '/es-log-spend',
    name: 'es_log_spend',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/LogSpend')
  },
  ES_OFFER_WALL_PERFORMANCE: {
    path: '/es-offerwall-performance',
    name: 'es_offer_wall_performance',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'es',
      title: 'Offerwall Performance',
      order: 6
    },
    component: () => import('@es_views/OfferWallPerformance')
  },
  ES_SETTINGS: {
    path: '/es-settings',
    name: 'es_settings',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/Settings')
  },
  ES_FRONTEND_SETTINGS: {
    path: '/es-frontend-settings',
    name: 'es_frontend_settings',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@ps_views/shared/frontend-settings/FrontendSettingsIndex.vue')
  },
  ES_CAMPAIGN_SETTINGS: {
    path: '/es-campaign-settings',
    name: 'es_campaign_settings',
    meta: { requiresAuth: true },
    props: { project: 'earn-star' },
    component: () => import('@ps_views/shared/campaign-settings/CampaignSettingsIndex.vue')
  },
  ES_TUNE_REJECTION_SETTINGS: {
    path: '/es-tune-rejection-settings',
    name: 'es_tune_rejection_settings',
    meta: { requiresAuth: true },
    props: { project: 'earn-star' },
    component: () => import('@ps_views/shared/tune-rejection-settings/TuneRejectionSettingsIndex.vue')
  },
  ES_TUNE_REJECTIONS: {
    path: '/es-tune-rejections',
    name: 'es_tune_rejections',
    meta: { requiresAuth: true },
    props: { project: 'earn-star' },
    component: () => import('@ps_views/shared/tune-rejections/TuneRejectionsIndex.vue')
  },
  ES_BONUS_CODES: {
    path: '/es-bonus-codes',
    name: 'es_bonus_codes',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/BonusCodes/BonusCodesIndex.vue')
  },
  ES_BONUS_CODE_REDEMPTIONS: {
    path: '/es-bonus-code-redemptions',
    name: 'es_bonus_code_redemptions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'es',
      title: 'Bonus Codes',
      order: 4
    },
    component: () => import('@es_views/BonusCodeRedemptions')
  },
  ES_ADJUST_CONFIG: {
    path: '/es-adjust-config',
    name: 'es_adjust_config',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@ps_views/shared/adjust-config/AdjustConfigIndex.vue')
  },
  ES_USER_CREDIT: {
    type: 'function',
    path: 'es_user_credit',
    name: 'es_user_credit',
    permission: 'es_user_credit',
    meta: {
      requiresAuth: true
    }
  },
  ES_DYNAMIC_CAMPAIGNS: {
    path: '/es-dynamic-campaigns',
    name: 'es_dynamic_campaigns_main',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns')
  },
  ES_DYNAMIC_CAMPAIGNS_EMAILS: {
    path: '/es-dynamic-campaigns/emails',
    name: 'es_dynamic_campaigns_emails',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns/Pages/Emails/CampaignsEmails.vue')
  },
  ES_DYNAMIC_CAMPAIGNS_EMAILS_CREATE: {
    path: '/es-dynamic-campaigns/emails/create',
    name: 'es_dynamic_campaigns_emails_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  ES_DYNAMIC_CAMPAIGNS_EMAILS_EDIT: {
    path: '/es-dynamic-campaigns/emails/edit/:id',
    name: 'es_dynamic_campaigns_emails_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  ES_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT: {
    path: '/es-dynamic-campaigns/emails/:id/translations/edit/:language_code',
    name: 'es_dynamic_campaigns_emails_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsTranslationsEdit.vue')
  },
  ES_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS: {
    path: '/es-dynamic-campaigns/push-notifications',
    name: 'es_dynamic_campaigns_push_notifications',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotifications.vue')
  },
  ES_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE: {
    path: '/es-dynamic-campaigns/push-notifications/create',
    name: 'es_dynamic_campaigns_push_notifications_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  ES_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT: {
    path: '/es-dynamic-campaigns/push-notifications/edit/:id',
    name: 'es_dynamic_campaigns_push_notifications_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  ES_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT: {
    path: '/es-dynamic-campaigns/push-notifications/:id/translations/edit/:language_code',
    name: 'es_dynamic_campaigns_push_notifications_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'earn-star' },
    component: () => import('@es_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsTranslationsEdit.vue')
  },
  ES_USER_REWARD_ELIGIBILITY_LOGS: {
    path: '/es-user-reward-eligibility-logs',
    name: 'es_user_reward_eligibility_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@es_views/Users/UserRewardEligibilityLogs')
  },
  ES_USER_LEVEL: {
    type: 'function',
    path: 'es_user_level',
    name: 'es_user_level',
    permission: 'es_user_level',
    meta: {
      requiresAuth: true
    }
  },
  ES_OVERWRITE_ELIGIBLE: {
    type: 'function',
    path: 'es_overwrite_eligible',
    name: 'es_overwrite_eligible',
    permission: 'es_overwrite_eligible',
    meta: {
      requiresAuth: true
    }
  }
}
